module.exports = __webpack_public_path__ + "img/组 188.ee64aa01.png";